import { Button } from '@/components/ui/Button';
import { Column } from '@/components/ui/layout/Column';
import { Text } from '@/components/ui/base/Text';
import { StepType } from '@reactour/tour';

export const dragAndDropSteps: StepType[] = [
  {
    selector: '.dropzone',
    content: (props) => (
      <Column>
        <Text>
          Pour finir, voici la zone où vous pourrez uploader vos fichiers pour
          les analyser à la fin de ce tutoriel.
        </Text>
        <Text>
          Vous pourrez glisser-déposer vos fichiers, ou bien cliquer sur la zone
          pour sélectionner vos fichiers.
        </Text>

        <Button
          className="my-1"
          onClick={() => {
            props.setCurrentStep((prev) => prev + 1);
          }}
        >
          Suivant
        </Button>
      </Column>
    ),
    position: 'bottom',
    highlightedSelectors: ['.dropzone'],
    mutationObservables: ['.dropzone'],
    stepInteraction: false,
  },
  {
    selector: '#tutorial-button',
    content: (props) => (
      <Column>
        <Text weight="bold">Vous avez terminé le tutoriel&nbsp;! 🥳</Text>
        <Text>
          Vous pouvez le relancer à tout moment en cliquant sur le bouton en bas
          à gauche de l'écran.
        </Text>
        <Button
          className="my-1"
          onClick={() => {
            props.setIsOpen(false);
          }}
        >
          Fermer le tutoriel
        </Button>
      </Column>
    ),
    position: 'center',
    stepInteraction: false,
    highlightedSelectors: ['body'],
  },
];
